import { environments } from '@/environment';
import { BootService } from '@/services/boot';

export function buildImageUrl(path: string, width?: number, height?: number): string {
  return path === ''
    ? ''
    : `${environments[BootService.env].imagesBaseUrl}/images/resized/w=${width || 100}${
        height ? `,h=${height}` : ''
      },q=75,f=auto,/produit/${path}`;
}

export function buildItemPhotoUrl(name: string, width?: number, height?: number): string {
  return name === ''
    ? ''
    : `${environments[BootService.env].imagesBaseUrl}/images/resized/w=${width || 100}${
        height ? `,h=${height}` : ''
      },f=auto/img/produit/${name}`;
}
